// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__tN1E3","form":"styles_form__1z2gc"};